import React from 'react';
import VoxelText from '../../../components/voxel/Text/VoxelText';

export interface SubPageWrapperProps {
  title?: string;
}

export const SubPageWrapper: React.FC<SubPageWrapperProps> = ({ title, children }) => {
  return (
    <div className="flex flex-col gap-4">
      <VoxelText variant="title2">{title}</VoxelText>
      <div>{children}</div>
    </div>
  );
};

export default SubPageWrapper;
